export default "__VITE_ASSET__PF6GiON3__"